<template>
  <div class="container-failure">
    <van-dialog v-model="showDia" :showConfirmButton="false" :closeOnClickOverlay="true" @close="close">
      <div class="dialog">
        <div class="con" v-if="con">{{ con }}</div>
        <div class="btn" @click="close">{{ $t('lang.OtherModule.k008') }}</div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
export default {
  props: {
    showDia: {
      default: false,
    },
    con: {},
  },
  data() {
    return {}
  },
  methods: {
    close() {
      this.$parent.closeDia()
    },
  },
}
</script>
<style lang="scss" scoped>
.container-failure {
  .dialog {
    width: 100%;
    padding: 30px 20px;
  }
  .con {
    width: 100%;
    margin: 0px 0 20px 0;
    font-size: 16px;
    font-family: 'Inter-Regular';
    font-weight: 500;
    color: #333333;
    line-height: 26px;
    text-align: center;
    overflow: hidden;
    white-space: pre-wrap;
    font-style: normal;
    > span {
      color: red;
    }
  }
  .btn {
    width: 200px;
    padding: 10px 0px;
    margin: 0 auto;
    white-space: wrap;
    text-align: center;
    background: #a338fc;
    border-radius: 20px;
    font-size: 16px;
    font-family: 'Inter-Regular';
    font-weight: 600;
    color: #ffffff;
  }
}
</style>
